export const PaymentStatus = {
  PrePaid: 'PrePaid',
  Unpaid: 'Unpaid',
  PreApproved: 'PreApproved',
  Approved: 'Approved',
  Processed: 'Processed',
  Others: 'Others'
};

export enum PaymentStatusEnum {
  None = 1,
  Unbilled = 2,
  Unpaid = 3,
  Approved = 4,
  Processed = 5,
  Paid = 6,
  Reject = 7,
  Denied = 8,
  Preapproved = 9,
  Capitated = 10
}



// WEBPACK FOOTER //
// ./src/app/core/enums/payment-status.enum.ts